export default {
    parseJwt: function (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
    },
    isExpired: function(exp) {
        if (exp === undefined) {            
            return null;
        }        
        // 네트워크 지연 시간을 고려하여 10초 만료 확인을 한다.        
        return Date.now() + (1000 * 10) >= exp * 1000;        
    }
}

